import * as React from 'react';
import { Stack } from '@mui/material';

import { SettingsAdditionalDetails } from './components/settings-additional-details';
import { UserDetails } from './components/user-details';
import { ThemeSwitch } from './components/theme-switch';

export function UserBasicDetails(): React.JSX.Element {
  return (
    <Stack spacing={3}>
      <UserDetails />
      <SettingsAdditionalDetails />
      <ThemeSwitch />
    </Stack>
  );
}
